export default {
    ORGANELL :'organell'
}